module.exports = __webpack_public_path__ + "static/media/clap.a6e86dd7.wav";


//////////////////
// WEBPACK FOOTER
// ./src/audio/row3/clap.wav
// module id = 60
// module chunks = 0